import PseRepository from '@/domain/repositories/PseRepository';
import PseDataStore from '../datastores/PseDataStore';
import PseDataStoreFactory from '../factories/PseDataStoreFactory';

export default class PseDataRepository implements PseRepository {
  getCaptcha() {
    const pseDataStore: PseDataStore = PseDataStoreFactory.create();
    return pseDataStore.getCaptcha();
  }

  registerInsuranceValidation(
    period: string,
    campus: string,
    ddjjSusaludDoc: boolean,
    ddjjInsuranceValidity: boolean,
    attachedFiles: any,
    isAutomated: boolean
  ) {
    const pseDataStore: PseDataStore = PseDataStoreFactory.create();
    return pseDataStore.registerInsuranceValidation(
      period,
      campus,
      ddjjSusaludDoc,
      ddjjInsuranceValidity,
      attachedFiles,
      isAutomated
    );
  }
}
